import request from '@/utils/request'
export function wechatJt(params) {
  return request({
    url: '/wechat/jt',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/wechat_api.js